var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',_vm._b({staticClass:"voc-switch",attrs:{"value":_vm.innerValue,"active-value":_vm.activeValue,"inactive-value":_vm.inactiveValue},on:{"change":_vm.onValueChanged}},'el-switch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }